import scrollAbleElementId from '../constants/scrollableElementId';

const getPDFScrollableDOMElement = () => document.getElementById(scrollAbleElementId);

export default getPDFScrollableDOMElement;
